import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuLayout from '../../layouts/MenuLayout';
import WebinarData from '../../components/pages/WebinarData';
import { fetchWebinarDetailsById } from '../../redux/features/coach/actions/coachAction';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/loader';

const WebinarDataDetails = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading2, webinarDetail } = useSelector((state) => state.coach.coach);
    const location = window?.location?.search?.split("=")[1];
    const [workShopData, setWorkShopData] = useState({
        data: {}
    });
    const [templateData, setTemplateData] = useState({});

    useEffect(() => {
        dispatch(fetchWebinarDetailsById({ payload: location }));
    }, []);

    useEffect(() => {
        let data =
            webinarDetail && Object.keys(webinarDetail).length > 0
                ? webinarDetail
                : state?.data;
        setWorkShopData(prev => ({
            ...prev,
            data: data
        }));
    }, [webinarDetail]);

    useEffect(() => {
        setTemplateData({
            section1: {
                heading: workShopData?.data?.section_1?.title ?? "",
                body: workShopData?.data?.section_1?.description ?? "",
            },
            section2: {
                heading: workShopData?.data?.section_2?.title ?? "",
                body: workShopData?.data?.section_2?.description ?? "",
                subHeading1: workShopData?.data?.section_2?.cards[0]?.title ?? "",
                subHeading2: workShopData?.data?.section_2?.cards[1]?.title ?? "",
                subHeading3: workShopData?.data?.section_2?.cards[2]?.title ?? "",
                subHeading4: workShopData?.data?.section_2?.cards[3]?.title ?? "",
                subBody1: workShopData?.data?.section_2?.cards[0]?.description ?? "",
                subBody2: workShopData?.data?.section_2?.cards[1]?.description ?? "",
                subBody3: workShopData?.data?.section_2?.cards[2]?.description ?? "",
                subBody4: workShopData?.data?.section_2?.cards[3]?.description ?? "",
            },
            section3: {
                heading: "Meet Nellie Padilla",
                body: "Founder Coach | Startup Strategist | Growth Guide",
                description: "Helping early-stage entrepreneurs turn ideas into launch-ready businesses with clarity, structure, and confidence. Nellie partners with solopreneurs and small teams to bring their ideas to life through strategic coaching, mindset support, and real-world launch tools."
            },
            section4: {
                heading: workShopData?.data?.section_4?.title ?? "",
                title: workShopData?.data?.section_4?.description ?? "",
                body1: workShopData?.data?.section_4?.cards[0]?.description ?? "",
                body2: workShopData?.data?.section_4?.cards[1]?.description ?? "",
                body3: workShopData?.data?.section_4?.cards[2]?.description ?? ""
            },
            section5: {
                heading: workShopData?.data?.section_5?.title ?? "",
                body: workShopData?.data?.section_5?.description ?? "",
                date: workShopData?.data?.section_5?.cards[0]?.title ?? "",
                time: workShopData?.data?.section_5?.cards[0]?.text_1 ?? "",
                duration: workShopData?.data?.section_5?.cards[0]?.text_2 ?? "",
                platform: workShopData?.data?.section_5?.cards[1]?.title ?? "",
                link: workShopData?.data?.section_5?.cards[1]?.text_1 ?? "",
                access: workShopData?.data?.section_5?.cards[1]?.text_2 ?? "",
                body1: workShopData?.data?.section_5?.cards[2]?.title ?? "",
            },
            section6: {
                faqs: workShopData?.data?.section_6
            },
        })
    }, [workShopData]);

    if (isLoading2) {
        return <Loader />;
    };
    return (
        <div>
            <MenuLayout>
                <WebinarData templateData={templateData} state={workShopData} />
            </MenuLayout>
        </div>

    )
};

export default WebinarDataDetails;